export default __webpack_public_path__ + "static/media/logo3.318be36f.png";